import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataFilterValues,
  ODataSubFilter,
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class SingleWorkspaceFilterModel implements ODataFilter {
  targetFieldId = '';
  childFieldName = '';
  filterGroup = FilterGroup.SystemChildFields;
  valueType = SearchValueType.WorkspaceMultiValue;
  subFilter = new ODataSubFilter();

  constructor(
    public targetField: string,
    public displayName: string,
    public values?: ODataFilterValues[]
  ) {}
  buildFilter(searchValue: ODataFilterValues[], filterOperator: FilterOperator) {
    if (this.valueType != SearchValueType.WorkspaceMultiValue) {
      throw new Error('Invalid Search Value Type');
    }

    if (
      filterOperator.displayOperator == FilterOperatorType.isEmpty ||
      filterOperator.displayOperator == FilterOperatorType.isNotEmpty
    ) {
      return ODataFilterBuilder.buildGuidFilter(
        this.targetField,
        null,
        filterOperator.actualOperator
      );
    }

    if (filterOperator.displayOperator == FilterOperatorType.in) {
      let filters = searchValue.map((value) => {
        return ODataFilterBuilder.buildGuidFilter(this.targetField, value.searchValue);
      });
      return { or: filters };
    }

    if (filterOperator.displayOperator == FilterOperatorType.notIn) {
      let filters = searchValue.map((value) => {
        return ODataFilterBuilder.buildGuidFilter(
          this.targetField,
          value.searchValue,
          FilterOperatorType.ne
        );
      });
      return { and: filters };
    }

    throw new Error('Invalid Operation');
  }
}
